import { DefaultRequest } from 'scripts/api';

class ReportTemplateRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'ReportTemplate';
        const model = App.Models.ReportTemplate;
        const collectionClass = App.Collections.ReportTemplates;

        super(entityName, model, collectionClass);
    }

    getProjection = () => {
        var projection = { "filters": ["id", "reportTemplates.*"], "firstResult": 0, "maxResults": 51 };
        var pagination = (App.Forms["ReportTemplate"] ? App.Forms["ReportTemplate"].pagination : null);

        if (pagination) {
            projection.firstResult = pagination.first;
            projection.maxResults = pagination.max;
        }

        return JSON.stringify(projection);
    }

    getCriteria = () => {
        var criteria = { criteriaChain: [{ and: [{ attr: "id", eq: Greenmile.Survey.Modal.UploadModal.surveyId }] }] };
        return JSON.stringify(criteria);
    }

    callbackSuccess = (data) => {
        var addPaginationGrid = true,
            tableLayout       = Monet.Grid.getGridLayout(App.Forms["ReportTemplate"].layout.index),
            pagination        = App.Forms["ReportTemplate"].pagination;

        if (pagination.first === 0) {
            Monet.Grid.addDataToGrid("ReportTemplate", tableLayout, data, addPaginationGrid);
        } else {
            Monet.Grid.appendDataToGridAfterPagination("ReportTemplate", tableLayout, data);
        }
    }

    filterCriteria = () => {
        var functionToCallback = function (data) {
            this.callbackSuccess(data);
        }.bind(this);

        const request = new DefaultRequest({
            url: 'Survey/restrictions?criteria=' + this.getProjection(),
            method: 'post',
            data: this.getCriteria(),
            success: function (data) {
                if (data[0]) {
                    data = data[0].reportTemplates || [];
                    var dataLenght = data.length,
                        collection = new App.Collections["ReportTemplates"];

                    for (var i = 0; i < dataLenght; i++) {
                        var model = new collection.model;
                        model.set(data[i]);

                        try {
                            collection.add(model);
                        } catch (err) {
                            console.log(err);
                        }
                    }
                    functionToCallback(collection);
                }
            }.bind(this)
        });
        request.send();
    }

    updateGrid = (filter, callback, appendCollection) => {
        var isAppendCollection = typeof appendCollection !== "undefined" && appendCollection === true;

        if (!isAppendCollection && this.local_collection && this.local_collection.reset) {
            this.local_collection.reset();
        }
        this.filterCriteria();
    }

    edit = (parentId, id) => {
        id = parseInt(parentId);
        var model = App.Forms.ReportTemplate.dataProvider.data.filter(function (item) {
            return item.idOfObject === id;
        });

        Greenmile.Survey.Modal.UploadModal.clear();
        var modal = new Greenmile.Survey.UploadWindow();
        modal.surveyId = Greenmile.Survey.Modal.UploadModal.surveyId;
        modal.model = {
            id: id,
            description: model[0].description,
            originalFileName: model[0].originalFileName
        };
        modal.showModalForm();
    }
}

App.Routers.ReportTemplate = ReportTemplateRouter;

